import { useCallback, useEffect, useState } from 'react'

// Synchronise la page affichée avec l'historique du navigateur.
// Chaque changement de page ajoute une entrée dans l'historique (URL /nom-de-page),
// ce qui fait que "Précédent" / "Suivant" naviguent entre les pages de l'app.
function pageFromUrl(validPages, defaultPage) {
  const slug = window.location.pathname.replace(/^\/+|\/+$/g, '')
  return validPages.includes(slug) ? slug : defaultPage
}

export default function usePageHistory(validPages, defaultPage) {
  const [page, setPageState] = useState(() => pageFromUrl(validPages, defaultPage))

  // Entrée initiale : on la normalise sans ajouter d'historique
  useEffect(() => {
    window.history.replaceState({ page }, '', '/' + page + window.location.search)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Boutons précédent / suivant du navigateur
  useEffect(() => {
    const onPopState = () => setPageState(pageFromUrl(validPages, defaultPage))
    window.addEventListener('popstate', onPopState)
    return () => window.removeEventListener('popstate', onPopState)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setPage = useCallback((next) => {
    setPageState(current => {
      if (next !== current) window.history.pushState({ page: next }, '', '/' + next)
      return next
    })
  }, [])

  return [page, setPage]
}
